var _path, _g, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHelpCenter = function SvgHelpCenter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 45 45"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "HelpCenter_svg__a",
    width: 45,
    height: 45,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h45v45H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#HelpCenter_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBF5FF",
    d: "M3.11 12.838V7.89a4.78 4.78 0 0 1 4.78-4.78h4.831"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M3.11 12.838V7.89a4.78 4.78 0 0 1 4.78-4.78h4.831"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBF5FF",
    d: "M12.826 41.89H7.889a4.78 4.78 0 0 1-4.78-4.78v-4.967"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M12.826 41.89H7.889a4.78 4.78 0 0 1-4.78-4.78v-4.967"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBF5FF",
    d: "M41.892 32.241v4.87a4.78 4.78 0 0 1-4.78 4.78h-4.866"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M41.892 32.241v4.87a4.78 4.78 0 0 1-4.78 4.78h-4.866"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBF5FF",
    d: "M32.336 3.11h4.776a4.78 4.78 0 0 1 4.78 4.78v4.874"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M32.336 3.11h4.776a4.78 4.78 0 0 1 4.78 4.78v4.874"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#HelpCenter_svg__b)",
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M26.327 35.153a13.06 13.06 0 0 1-3.706.534 13.06 13.06 0 0 1-3.706-.534 13.094 13.094 0 0 1-8.826-8.826 13.059 13.059 0 0 1-.534-3.706c0-1.287.187-2.531.534-3.706a13.095 13.095 0 0 1 8.826-8.826 13.06 13.06 0 0 1 3.706-.534c1.288 0 2.531.187 3.706.534a13.095 13.095 0 0 1 8.826 8.826 13.06 13.06 0 0 1 .534 3.706c0 1.288-.186 2.531-.534 3.706a13.094 13.094 0 0 1-8.826 8.826m17.41-17.2C41.933 9.76 35.483 3.31 27.289 1.505A21.667 21.667 0 0 0 22.621 1c-1.603 0-3.165.174-4.668.505C9.76 3.31 3.31 9.76 1.505 17.953A21.665 21.665 0 0 0 1 22.621c0 1.603.174 3.165.505 4.668C3.31 35.483 9.76 41.933 17.953 43.737c1.503.331 3.065.505 4.668.505 1.603 0 3.165-.174 4.668-.505 8.194-1.804 14.644-8.254 16.448-16.448.331-1.503.505-3.065.505-4.668 0-1.603-.174-3.165-.505-4.668"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m19.064 9.887-.923-8.24M27.103 1.646l-.923 8.24M18.14 43.596l.924-8.24M26.18 35.355l.923 8.24M43.596 27.102l-8.24-.924M35.356 19.063l8.24-.924M1.645 18.14l8.24.922M9.885 26.178l-8.24.924"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBF5FF",
    d: "M25.5 9.5c.333-2.167 1-6.7 1-7.5 0-.8-5-.333-7.5 0l.5 7.5zM36 25.5c2.167.333 6.7 1 7.5 1 .8 0 .333-5 0-7.5l-7.5.5zM9.5 19.5c-2.167-.333-7.258-.5-8.058-.5-.8 0-.334 5 0 7.5L9 26zM19.5 36c-.333 2.167-.5 6.7-.5 7.5 0 .8 5 .333 7.5 0L26 36z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M26.327 35.153a13.06 13.06 0 0 1-3.706.534 13.06 13.06 0 0 1-3.706-.534 13.094 13.094 0 0 1-8.826-8.826 13.059 13.059 0 0 1-.534-3.706c0-1.287.187-2.531.534-3.706a13.095 13.095 0 0 1 8.826-8.826 13.06 13.06 0 0 1 3.706-.534c1.288 0 2.531.187 3.706.534a13.095 13.095 0 0 1 8.826 8.826 13.06 13.06 0 0 1 .534 3.706c0 1.288-.186 2.531-.534 3.706a13.094 13.094 0 0 1-8.826 8.826m17.41-17.2C41.933 9.76 35.483 3.31 27.289 1.505A21.667 21.667 0 0 0 22.621 1c-1.603 0-3.165.174-4.668.505C9.76 3.31 3.31 9.76 1.505 17.953A21.665 21.665 0 0 0 1 22.621c0 1.603.174 3.165.505 4.668C3.31 35.483 9.76 41.933 17.953 43.737c1.503.331 3.065.505 4.668.505 1.603 0 3.165-.174 4.668-.505 8.194-1.804 14.644-8.254 16.448-16.448.331-1.503.505-3.065.505-4.668 0-1.603-.174-3.165-.505-4.668"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "HelpCenter_svg__b",
    x1: 5.621,
    x2: 42.621,
    y1: 5.121,
    y2: 44.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2561"
  })))));
};
export default SvgHelpCenter;